/* eslint-disable import/prefer-default-export */
export const SET_AVAILABLE_PLANS = 'SET_AVAILABLE_PLANS';
